import clsx from 'clsx';
import React from 'react';
import { TitleType } from '../../utils/utils';

interface TitleProps {
  children?: React.ReactNode;
  type: TitleType;
  bold?: boolean;
  centered?: boolean;
  className?: string;
}


export const Title: React.FC<TitleProps> = ({ 
  children, 
  type, 
  bold = false,
  centered = false,
  className = "" 
}) => {

  const classes = clsx(
    centered && 'text-center',
    bold && 'font-bold',
    className,
  );

  switch (type) {
    case 'h1':
      return <h1 className={`text-5xl font-title ${classes}`}>{children}</h1>;
    case 'h2':
      return <h2 className={`text-4xl font-title ${classes}`}>{children}</h2>;
    case 'h3':
      return <h3 className={`text-3xl font-title ${classes}`}>{children}</h3>;
    case 'h4':
      return <h4 className={`text-2xl font-title ${classes}`}>{children}</h4>;
    case 'h5':
      return <h5 className={`text-xl font-title ${classes}`}>{children}</h5>;
    case 'h6':
      return <h6 className={`text-lg font-title ${classes}`}>{children}</h6>;
    case 'display':
      return <div className={`title-display ${classes}`}>{children}</div>;
    case 'subdisplay':
      return <div className={`title-subdisplay ${classes}`}>{children}</div>;
    default:
      return <h1 className={`text-5xl ${classes}`}>{children}</h1>;
  }
};